import React from 'react';
/**
 * Decorative background layer for the hero.
 *
 * PERF NOTE: This used to use framer-motion with 5 animated children, an
 * external grainy-gradients.vercel.app image, and 2 continuously animated
 * SVG-rotation rings. All of that ran on the main thread before LCP.
 *
 * Now it's a single static element with two pure-CSS pulses. ~0ms init cost.
 */
export function FloatingElements() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" aria-hidden="true" data-id="element-2340">
      {/* Soft red glow — top right */}
      <div className="absolute top-1/4 right-1/4 w-32 h-32 rounded-full" style={{
      background: 'rgba(255,0,0,0.10)',
      filter: 'blur(100px)',
      animation: 'fePulseRed 4s ease-in-out infinite'
    }} data-id="element-2341" />
      {/* Soft gold glow — bottom left */}
      <div className="absolute bottom-1/4 left-1/4 w-40 h-40 rounded-full" style={{
      background: 'rgba(255,215,0,0.06)',
      filter: 'blur(120px)',
      animation: 'fePulseGold 5s ease-in-out infinite'
    }} data-id="element-2342" />
      {/* Subtle dashed ring — pure CSS, no JS animation loop */}
      <div className="absolute top-20 left-10 w-64 h-64 rounded-full border border-dashed" style={{
      borderColor: 'rgba(255,0,0,0.10)',
      opacity: 0.2,
      animation: 'feSpin 60s linear infinite'
    }} data-id="element-2343" />
      <style data-id="element-2344">{`
        @keyframes fePulseRed { 0%, 100% { opacity: .8 } 50% { opacity: 1 } }
        @keyframes fePulseGold { 0%, 100% { opacity: .8 } 50% { opacity: 1 } }
        @keyframes feSpin { to { transform: rotate(360deg) } }
        @media (prefers-reduced-motion: reduce) {
          [aria-hidden="true"] * { animation: none !important }
        }
      `}</style>
    </div>;
}